import Header from "./Header";
import Footer from "./Footer";
import lineRobot from '../images/line-robot.png'
import twoRobots from "../images/two-robots.png";
import robotFace from '../images/robot-face.png';
import ContactForm from "./ContactForm";
import LazyLoad from "./LazyLoad";

function About() {

    return (
        <div className={"about page"}>
            <Header/>
            <div className={"page-heading"}>ABOUT US</div>
            <div className={"content"}>
                <div className={"about-page-text"}>
                    <div className={"about-section open center row"}>
                        <div className={"half-section"}>
                            <img src={lineRobot} alt={"line-robot"} className={"enclosed-image"}/>
                        </div>
                        <div className={"half-section"}>
                            <div className={"section-heading"}>What We Do</div>
                            <p className={"section-content"}>
                                Rexius Algorithms builds software that takes work off your plate. We automate
                                repetitive tasks, bring AI into the tools you already use, and build custom
                                applications around the way your business actually runs.
                                <br/>
                                <br/>
                                Every project is built for your specific needs, and once it's live we handle the
                                hosting and maintenance so it keeps running without you having to manage it.
                            </p>
                        </div>
                    </div>
                    <div className={"section enclosed mobile-negative-margin-top-2"}>
                        <div className={"row align-items-center"}>
                            <div className={"half-section"}>
                                <LazyLoad>
                                    <img src={twoRobots} alt={"two-robots"} className={"enclosed-image scale-up"}/>
                                </LazyLoad>
                            </div>
                            <div className={"half-section"}>
                                <LazyLoad>
                                    <div className={"slide-in-right"}>
                                        <div className={"section-heading"}>Our Services</div>
                                        <p className={"section-content"}>
                                            Whether you need a single scheduled task or a full application, we design,
                                            build, and run the solution for you.
                                        </p>
                                    </div>
                                </LazyLoad>
                            </div>
                        </div>
                        <div>
                            <div className={"section-subheading"}>AI Integrations</div>
                            <p className={"section-content"}>
                                Put AI to work in your business: chatbots and assistants, document and email
                                processing, data extraction and summarization, and AI features built directly into
                                your existing software.
                            </p>
                            <div className={"section-subheading"}>Custom Applications</div>
                            <p className={"section-content"}>
                                Web apps, internal tools, dashboards, and client portals designed around your
                                process, instead of forcing you into off-the-shelf software that doesn't quite fit.
                            </p>
                            <div className={"section-subheading"}>Automation</div>
                            <p className={"section-content"}>
                                Scheduled tasks, automated reports and emails, and workflows that run on their own,
                                around the clock, without manual effort.
                            </p>
                            <div className={"section-subheading"}>Financial Automation</div>
                            <p className={"section-content"}>
                                Trading algorithms, market data processing, and financial reporting built to run
                                reliably and precisely.
                            </p>
                            <div className={"section-subheading"}>System Integrations</div>
                            <p className={"section-content"}>
                                Connect the platforms and APIs you already rely on so data moves between them
                                automatically, with no copying and pasting.
                            </p>
                            <div className={"section-subheading"}>Hosting and Maintenance</div>
                            <p className={"section-content last-line"}>
                                We host, monitor, and maintain everything we build, including server setup, updates,
                                and fixes.
                            </p>
                        </div>
                    </div>
                </div>
                <div className={"section open center margin-bottom-2"}>
                    <div className={"row align-items-center"}>
                        <div className={"half-section"}>
                            <div className={"section-heading"}>How We Work</div>
                            <p className={"section-content"}>
                                <span className={"bold"}>Reach Out</span> - Send us a message through the form below
                                with a short description of what you need.
                                <br/>
                                <br/>
                                <span className={"bold"}>Consultation</span> - We'll talk through your goals and
                                give you a clear price estimate.
                                <br/>
                                <br/>
                                <span className={"bold"}>Build</span> - We develop a solution tailored to your
                                requirements and connect it to your existing systems.
                                <br/>
                                <br/>
                                <span className={"bold"}>Ongoing Support</span> - We host and maintain it after
                                launch so it keeps running smoothly.
                            </p>
                        </div>
                        <div className={"half-section"}>
                            <img src={robotFace} alt={"robot-face"} className={"enclosed-image"}/>
                        </div>
                    </div>
                </div>
                <ContactForm/>
            </div>
            <Footer/>
        </div>

    )
}

export default About;
